<template>
  <section class="programs-block">
    <AppLayoutContainerFull :flush="true" class="programs-block__layout-container-full">
      <AppHeadingTitleSubtitle :title="props.data.title" :subtitle="props.data.subtitle" :styling="props.data.styling"/>
    </AppLayoutContainerFull>
    <swiper
        slides-per-view="auto"
        class="programs-block__slider swiper-fade-in"
        :watch-overflow="true"
        @swiper="useSwiper"
    >
      <swiper-slide
          v-for="(program, index) in data.programs"
          :key="`program_${index}`"
          class="programs-block__slider-slide"
      >
        <AppProgramCard
            :data="program.program_page"
            :in-slider="true"
        />
      </swiper-slide>

      <AppSwiperControls >
        <AppButton v-if="data.list_page_button_label" url="/program/" :title="data.list_page_button_label" :end-icon="true"/>
      </AppSwiperControls>

    </swiper>
  </section>
</template>

<script setup lang="ts">
import {Swiper, SwiperSlide} from 'swiper/vue'
import 'swiper/css'
import {TProgramsBlock} from '~/types/block-types'
import {useSwiper} from "~/composables/useSwiper";

const props = defineProps<{
  data: TProgramsBlock,
}>()

</script>

<style scoped lang="postcss">
.programs-block {
  width: 100%;
  overflow: clip;
  padding-bottom: 0.25rem;
  @mixin app-block-margins;

  &__layout-container-full {
    @mixin app-content-block-title-margins;
  }

  &__slider {
    margin-left: -1rem;
    margin-right: -1rem;
    margin-top: -0.375rem;
    padding-top: 0.375rem;
    /* 1.5 is for the border hover of 6px */
  }

  &__slider-slide {
    margin-right: 0.75rem;
    width: fit-content;

    &:last-child {
      margin-right: 0px;
    }
  }
}
</style>
